const INITIAL_STATE = {
  data: {},
  errors: {},
}
const getGeneratedInvoice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'POST_WORK_ORDERS_GENERATE_INVOICE_SUCCESSFULLY':
	  return { ...INITIAL_STATE, data: action.data }
  case 'POST_WORK_ORDERS_GENERATE_INVOICE_FAILED':
	  return { ...INITIAL_STATE, errors: action.data }
  default:
	  return { ...state }
  }
};
		
export default getGeneratedInvoice;